module.exports = __webpack_public_path__ + "1fb0fb1518f94271fb6289534244a24b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/side-table.png
// module id = 986
// module chunks = 0